import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import T180 from "../../../components/calculator/T180";
import T21 from "../../../components/calculator/T21";
import useCalculator from "../../../hooks/useCalculator";

function CalculadoraReplicaPGI() {
  const [key, setKey] = useState(false);
  const { calculator } = useCalculator();

  return (
    <>
      <div id="blur-prueba">
        <div className="botton-editar-pginews margin-boton-world">
          <button className=" settings_button-pleno overlay-replica-button">
            {" "}
            <a href="/pgi/edit-calculadora">Editar Sección Calculadora</a>
          </button>
        </div>
        <div
          id="calculadora"
          aria-labelledby="calculadora-intro"
          className="bg-fullpage zindex-pgi"
        >
          {/* <img src={fondo} alt="" className="imagen-fondo" /> */}

          {key ? (
            <picture>
              <source
                media="(orientation: portrait) and (max-width: 767px)"
                srcSet={
                  calculator?.t180?.[0]?.imageCover_mobile
                    ? calculator?.t180?.[0]?.imageCover_mobile?.[0]?.url
                    : ""
                }
                alt={
                  calculator?.imageCover_mobile
                    ? calculator?.t180?.[0]?.imageCover_mobile?.[0].alt
                    : ""
                }
                className="imagen-fondo img-responsive-inter"
                title="calculadora"
              />
              <source
                media="(orientation: landscape) and (max-width: 767px)"
                srcSet={
                  calculator?.t180?.[0]?.imageCover
                    ? calculator?.t180?.[0]?.imageCover?.[0]?.url
                    : ""
                }
                alt={calculator?.imageCover ? calculator?.t180?.[0]?.imageCover?.[0]?.alt : ""}
                className="imagen-fondo img-responsive-inter"
                title="calculadora"
              />
              <img
                className="imagen-fondo img-responsive-inter"
                src={
                  calculator?.t180?.[0]?.imageCover
                    ? calculator?.t180?.[0]?.imageCover?.[0]?.url
                    : ""
                }
                alt={calculator?.imageCover ? calculator?.t180?.[0]?.imageCover?.[0]?.alt : ""}
                title="calculadora"
              />
            </picture>
          ) : (
            <picture>
              <source
                media="(orientation: portrait) and (max-width: 767px)"
                srcSet={
                  calculator?.t21?.[0]?.imageCover_mobile
                    ? calculator?.t21?.[0]?.imageCover_mobile?.[0]?.url
                    : ""
                }
                alt={
                  calculator?.imageCover_mobile
                    ? calculator?.t21?.[0]?.imageCover_mobile?.[0]?.alt
                    : ""
                }
                className="imagen-fondo img-responsive-inter"
                title="calculadora"
              />
              <source
                media="(orientation: landscape) and (max-width: 767px)"
                srcSet={
                  calculator?.t21?.[0]?.imageCover ? calculator?.t21?.[0]?.imageCover?.[0]?.url : ""
                }
                alt={calculator?.imageCover ? calculator?.t21?.[0]?.imageCover?.[0]?.alt : ""}
                className="imagen-fondo img-responsive-inter"
                title="calculadora"
              />
              <img
                className="imagen-fondo img-responsive-inter"
                src={
                  calculator?.t21?.[0]?.imageCover ? calculator?.t21?.[0]?.imageCover?.[0]?.url : ""
                }
                alt={calculator?.imageCover ? calculator?.t21?.[0]?.imageCover?.[0]?.alt : ""}
                title="calculadora"
              />
            </picture>
          )}

          <div className="container">
            {key ? (
              <header id="calculadora-intro">
                <h1>{calculator?.t180?.[0]?.title}</h1>
                <p>
                  <b>{calculator?.t180?.[0]?.subtitle}</b>
                </p>
                <p>{calculator?.t180?.[0]?.description}</p>
              </header>
            ) : (
              <header id="calculadora-intro">
                <h1>{calculator?.t21?.[0]?.title}</h1>
                <p>
                  <b>{calculator?.t21?.[0]?.subtitle}</b>
                </p>
                <p>{calculator?.t21?.[0]?.description}</p>
              </header>
            )}

            <Box className="tabs-contact">
              <Tabs aria-label="icon label tabs example">
                <Tab
                  value="T21"
                  className={`icon-tab ${!key && "active"}`}
                  label="T21"
                  aria-labelledby="Calculadora T21"
                  aria-label="Calculadora T21"
                  onClick={() => setKey(false)}
                />
                <Tab
                  value="T180"
                  className={`icon-tab ${key && "active"}`}
                  label="T180"
                  aria-labelledby="Calculadora T180"
                  aria-label="Calculadora T180"
                  onClick={() => setKey(true)}
                />
              </Tabs>
            </Box>
          </div>
        </div>

        {key ? <T180 /> : <T21 />}
      </div>
    </>
  );
}

export default CalculadoraReplicaPGI;
